import { createContainer as createContainerBase } from '@nzyme/ioc/Container.js';
import { effectScope as createEffectScope, getCurrentScope } from 'vue';
import { injectionKey } from './injectionKey.js';
/** Creates a Vue-aware IoC container that resolves services within a Vue effect scope. */
export function createContainer(options) {
    const parent = options?.parent;
    const effectScope = parent ? (getCurrentScope() ?? parent.effectScope) : createEffectScope(true);
    const container = createContainerBase({
        parent,
        createChild: () => createContainer({ parent: container }),
        resolve: (resolvable, scope) => {
            const current = getCurrentScope();
            if (current === effectScope) {
                return resolvable.resolve(container, scope);
            }
            return effectScope.run(() => {
                return resolvable.resolve(container, scope);
            });
        },
    });
    container.effectScope = effectScope;
    container.injectionKey = injectionKey;
    return container;
}
//# sourceMappingURL=createContainer.js.map